import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {SharedModule} from '@shared/shared.module';
import {DisplayConsentModule} from '../display-consent/display-consent.module';
import {StoreModule} from '@ngrx/store';
import {A11yModule} from '@angular/cdk/a11y';
import {MatIconModule} from '@angular/material/icon';
import {EffectsModule} from '@ngrx/effects';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatMenuModule} from '@angular/material/menu';
import {InformationUnitEditorComponent} from './components/indication-management/information-unit-editor/information-unit-editor.component';
import {CmsIndicationEditComponent} from './components/indication-management/cms-indication-edit/cms-indication-edit.component';
import {MatSidenavModule} from '@angular/material/sidenav';
import {CmsReducer} from './store';
import {CmsEffects} from './store/cms-effects';
import {CmsContainerComponent} from './container/cms-container.component';
import {ImageGalleryComponent} from './components/image-management/image-gallery/image-gallery.component';
import {FileUploadModule} from '../file-upload/file-upload.module';
import {CmsIndicationListComponent} from './components/indication-management/cms-indication-list/cms-indication-list.component';
import {EditorGuard} from '../../../../../auth/keycloak-editor.guard';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {DeleteInfoDialogComponent} from './dialogs/delete-info-dialog/delete-info-dialog.component';
import {CoreModule} from '@core/core.module';
import {NewIndicationPopupComponent} from './components/indication-management/pop-ups/new-indication-popup/new-indication-popup.component';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {CmsOutlineComponent} from './components/indication-management/cms-menu/cms-outline/cms-outline.component';
import {CmsMenuComponent} from './components/indication-management/cms-menu/cms-menu.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {InfiniteScrollModule} from "ngx-infinite-scroll";

const routes: Routes = [
    {
        path: 'cms',
        component: CmsContainerComponent,
        canActivate: [EditorGuard],
        children: [
            {path: '', redirectTo: 'indications', pathMatch: 'full'},
            {path: 'indications', component: CmsIndicationListComponent},
            {path: 'indications/:id', component: CmsIndicationEditComponent},
            {path: 'images', component: ImageGalleryComponent}
        ]
    }
];

@NgModule({
    declarations: [
        CmsIndicationEditComponent,
        InformationUnitEditorComponent,
        CmsContainerComponent,
        CmsIndicationListComponent,
        ImageGalleryComponent,
        DeleteInfoDialogComponent,
        NewIndicationPopupComponent,
        CmsOutlineComponent,
        CmsMenuComponent
    ],
    exports: [],
    imports: [
        RouterModule.forChild(routes),
        StoreModule.forFeature(CmsReducer.REDUCER_NAME, CmsReducer.cmsReducer),
        EffectsModule.forFeature([CmsEffects]),
        CommonModule,
        TranslateModule,
        SharedModule,
        DisplayConsentModule,
        A11yModule,
        MatIconModule,
        FormsModule,
        MatMenuModule,
        MatSidenavModule,
        ReactiveFormsModule,
        FileUploadModule,
        ClipboardModule,
        CoreModule,
        MatInputModule,
        MatFormFieldModule,
        DragDropModule,
        InfiniteScrollModule
    ]
})
export class CmsModule {
}
